import React from 'react';
import { Box, Grid, Grow, Typography } from '@mui/material';
import SignInImg from 'Assets/Images/login.png'
import SignInForm from './SignInForm';

export default function SignInPage() {

    return (
        <Grid container sx={{ minHeight: '100dvh', background: 'linear-gradient(to right, #041e42, #78a8e6)', overflow: 'auto' }}>
            <Grow in timeout={1000}>
                {/* Left side */}
                <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#fff', px: 4, mt: 4 }}>
                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        WELCOME TO TAS
                    </Typography>
                    <Typography variant="h6" gutterBottom>
                        Trusted Advisory Service
                    </Typography>
                    <Box component="img" src={SignInImg} alt="illustration" sx={{ width: '60%', maxWidth: 400, mt: 4 }} />
                </Grid>
            </Grow>

            {/* Right side */}
            <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ width: '100%', maxWidth: 400, p: 4, pb: 1 }}>
                    <Typography variant="h3" align="center" sx={{ mb: 1 }}>
                        <span style={{ color: "#fff" }}>T</span>
                        <span style={{ color: "#fbb034" }}>A</span>
                        <span style={{ color: "#fff" }}>S</span>
                    </Typography>
                    <Typography align="center" sx={{ color: "#e0e0e0", mb: 2 }}>
                        LET'S CONNECT
                    </Typography>
                </Box>
                <SignInForm />
            </Grid>
        </Grid>
    );
}
